import React, { useState } from 'react'
import { Message } from '../type'
import Text from '../../Text'
import { Fetch } from '@polvo-labs/react-auth'
import RealtyType from '../../../models/Realty'
import Realty from './Realty'
import Loader from '../../Loader'
import { Text as TextContainer, RealtyContainer } from './styles'

interface Props {
  type: 'sent' | 'received'
  message: Message
}

const TextMessage: React.FC<Props> = ({ message }) => {
  const regex = /#([0-9]+)/g.exec(message.content!)
  const [key, setKey] = useState(0)

  return (
    <TextContainer>
      <Text
        tag="span"
        color="black"
      >
        {message.content}
      </Text>

      {regex && regex.length > 1 && (
        <RealtyContainer>
          <Fetch
            key={key}
            url={`${process.env.REACT_APP_API_URL}/realties/${regex[1]}`}
            loader={() => <Loader />}
          >
            {({ data }) => data && data.data ? (
              <Realty
                realty={data.data as RealtyType}
                onUpdated={() => setKey(prev => prev + 1)}
              />
            ) : (
              <Text
                tag="span"
                size="hint"
                align="center"
              >
                Não foi encontrado imóvel com esse identificador
              </Text>
            )}
          </Fetch>
        </RealtyContainer>
      )}
    </TextContainer>
  )
}

export default TextMessage
